import DashboardAlert from "../../../components/dashboard/DashboardAlert";
import "./Dashboard.scss";

import DashboardHeaderSection from "./DashboardHeaderSection";
import LatestChatBots from "./LatestChatBots";
import LatestHumanClones from "./LatestHumanClones";

const Dashboard = () => (
  <section className="home-page tw-pb-4">
    <DashboardAlert />
    <DashboardHeaderSection />

    <LatestChatBots />

    <LatestHumanClones />
  </section>
);

export default Dashboard;
